module.exports = __webpack_public_path__ + "static/media/sunset_17.919bc61a.webp";